<script lang="ts" setup>
import PicIcon from "@/components/icon/PicIcon.vue";
import { ref } from "vue";
import MediaSelectPopup from "@/components/mobile/media/MediaSelectPopup.vue";
import { MediaUploadFileItem } from "@/types/component";
import { Editor } from "@tiptap/vue-3";

const props = withDefaults(
  defineProps<{
    storyId: number;
    disabled?: boolean;
    editor: Editor;
  }>(),
  {
    disabled: false,
  }
);

const mediaList = ref<MediaUploadFileItem[]>([]);
const showMediaSelect = ref(false);
const onImageUploaded = (newMediaList: MediaUploadFileItem[]) => {
  props.editor.chain().focus().setImage({ src: newMediaList[0].url }).run();
  mediaList.value = [];
};
</script>
<template>
  <button
    :disabled="disabled"
    class="btn btn-xs md:btn-sm btn-ghost rounded"
    @click="showMediaSelect = true"
  >
    <i class="iconify mingcute--pic-line" />
  </button>
  <media-select-popup
    ref="imgSelectPopupRef"
    v-model:media-list="mediaList"
    v-model:show="showMediaSelect"
    :max-count="1"
    :multiple="false"
    :story-id="storyId"
    :upload-type="8"
    media-type="img"
    @on-media-selected="onImageUploaded"
  />
</template>
